export default "__VITE_ASSET__EZsPinid__"